import * as React from "react";

import { Modal } from "../../../components";

export interface ModalProps {
  handleClose: () => void;
  isOpen: boolean;
}

const AccountModal = (props: ModalProps) => (
  <Modal {...props}>
    <div className="phone-input-modal">
      <h3 className="text-center">Tính năng đang hoàn thiện!</h3>
      <p className="text-center">
        Chức năng Dashboard đang được xây dựng. <br />
        Chúng tôi sẽ liên hệ với bạn khi đơn hàng được tiếp nhận. <br />
        Nhấn OK để quay về trang chủ.
      </p>
      <button className="close-btn" onClick={props.handleClose}>
        OK
      </button>
    </div>
  </Modal>
);

export default AccountModal;



// WEBPACK FOOTER //
// ./src/routes/Account/components/AccountModal.tsx